import { Button } from "@/components/ui/button";
import WithTooltip from "./with-tooltip";


interface TooltipButtonProps extends Omit<React.ComponentProps<typeof Button>, 'onClick' | 'children'> {
    tooltip: string;
    onClick: () => void;
    icon: React.ComponentType<{ className?: string }>;
}

const TooltipButton = ({
    tooltip,
    onClick,
    icon: Icon,
    ...props
}: TooltipButtonProps) => (
    <WithTooltip tooltip={tooltip}>
        <Button
            variant='outlinelight'
            aria-label={tooltip}
            size='icon'
            onClick={onClick}
            {...props}
        >
            <Icon className="h-4 w-4 text-zinc-600" />
        </Button>
    </WithTooltip>
);

export default TooltipButton;